import "./Footer.css";

const Footer = () => {
  return (
    <footer className="user-footer">
      <span>Made in India for JT Attorney Alliance</span>
    </footer>
  );
};

export default Footer;